export const obtenerObjLocal = ({key}) => {

    let string = window.localStorage.getItem(key)
    if (string) {
        let obj = JSON.parse(string)
        return obj
    } else {
        return false
    }


}